import React, {Component, useContext, useEffect} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as updateConfigurationActions from '../../../actions/updateConfigurationActions';
import * as uiActions from '../../../actions/uiActions';
import {ModalButton} from '../../../components/ModalButton';
import {Lines} from '../ConfiguratorCompletion';
import {Totals} from './CompletionTotals';
import { TranslationContext } from "../../../context/TranslationContext";
import { gtmPro } from "../../../services/gtmPro";

export class DetailsComponent extends Component {
  static contextType = TranslationContext;

  constructor(props) {
    super(props);
    this.state = {
      isOpen: true
    };
  }

  handleCloseModal = () => {
    this.setState({ isOpen: false });
  };

  handleDetailsClick = () => {
    gtmPro().ctaOfConfiguration(
      {
        name: "extranet.config3d.config3d_actionbuttons_details",
        category: "configurateur",
        subcategory: "Détails",
        type: "cta",
        from: "right"
      },
      {},
      {},
      "partner",
      "product",
      "user",
      "page"
    );
  };

  render() {
    const t = this.context;
    const additionalInfo = t("config3d_actionbuttons_details") || "Détails";
    const { disabled } = this.props;

    return (
      <div className="btn-wrapper">
        <ModalButton
          buttonContent="Détails"
          // openModal={this.state.isOpen}
          buttonIcon="finalization-icon"
          className={`ConfigurationDetailsPopupModal ${disabled ? 'disabled' : ''}`}
          disabled={disabled}
          overlayClassName="ConfigurationDetailsPopupModalOverlay"
          onClick={this.handleDetailsClick}
          additionalInfo={additionalInfo}
          buttonClassName={`btn-config-secondary text-dark background-page ${!disabled && 'secondary3-hover text-dark-border'}`}
        >
          <ModalConfigurationDescription onRequestClose={this.handleCloseModal} />
        </ModalButton>
      </div>
    );
  }
}
export const Details = connect()(DetailsComponent);


function ModalConfigurationDescriptionComponent(props) {
  const t = useContext(TranslationContext);
  const {uiActions, onRequestClose} = props;
  const {showBuyingPrices, showSellingPrices} = props.ui;

  useEffect(() => {
    const bottomValue = showSellingPrices ? '140px' : '80px';
    document.getElementById('configuration-details').style.bottom = bottomValue;
  }, [showSellingPrices]);

  return (
    <div className="ConfigurationDetailsPopup">
      <div className="Header">
        <div className="HeaderContainer">
          <h1>{t("config3d_finalize_quote-modal_title") || "Détails du projet"}</h1>
        </div>
      </div>
      <section className="ConfigurationDetails" id="configuration-details">
        <div className="ConfigurationDetailsScroll" style={{
          marginBottom: showSellingPrices ? "13.3rem" : "8.3rem",
        }}>
          <div className='row my-3'>
            <div className='col-8'></div>
            <div className='col-2 price-title d-flex justify-content-around'>
            {showSellingPrices ? (
              <>
                {(showBuyingPrices && showSellingPrices) && <span>{t("config3d_finalize_quote-modal_purchase-price") || "Prix d’achat"}</span>}
              </>
            ) : (
              <></>
            )}
            </div>
            <div className='col-2 price-title'>
              {showSellingPrices && <span>{t("config3d_finalize_quote-modal_selling-price") || "Prix de vente"}</span>}
            </div>
          </div>

          <Lines {...props} isDetailsModal={true} />
        </div>
      </section>
      <div className="Footer">
        <Totals {...props} isDetailsModal={true} onRequestClose={onRequestClose} />
      </div>
    </div>
  )
}

export const ModalConfigurationDescription = connect(
  state => ({
    canChangePrice: true,
    ui:state.ui,
    user: state.user,
    configurator: state.configurator,
    ...state.configurator.current
  }),

  dispatch => ({
    actions: bindActionCreators(updateConfigurationActions, dispatch),
    uiActions: bindActionCreators(uiActions, dispatch)
  })
  
)(ModalConfigurationDescriptionComponent);